// extracted by mini-css-extract-plugin
export default {"cls1":"GBB6RSCQfxs8hW6WIjQN","cls2":"QsNGOCmHTzwm7l_DdTwF GBB6RSCQfxs8hW6WIjQN"};